import { AuthService } from './../../../services/auth.service';
import { AgentService } from './../../../services/agent.service';
import { ProfilService } from './../../../services/profil.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Agent } from './../../../models/Agent';
import { SelectItem, Message, ConfirmationService } from 'primeng/primeng';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.css']
})
export class ProfilComponent implements OnInit {
  colorFieldset = 'primary';
  colorPanel = 'primary';
  droit: boolean;
  titre = 'Gestion des Agents';
  msgs: Message[] = [];
  growlDefaultLife: number;
  items: Agent[] = [];
  item: Agent;
  editMode = true;
  displayDialog = false;
  itemId: any;
  totalElements: number;

  confirmation: string;
  listProfil: SelectItem[];
  listPoint: SelectItem[];
  listCategorie: SelectItem[];

  searchLibelle: string;
  searchPoint: string;
  searchProfil: string;

  displaychargement = false;
  formValid = false;
  form: FormGroup;
  formErrors = {
    login: '',
    password: '',
    nom: '',
    prenom: '',
    profil: '',
    email: '',
    telephone: '',
    role: '',
    confirmer: ''
  };
  validationMessages = {
    login: { required: 'Login est requis.' },
    password: { required: 'Mot de passe est requis.' },
    confirmation: { required: 'Confirmation est requis.', confirm: 'Mot de pass non conforme.' },
    nom: { required: 'Nom est requis.' },
    prenom: { required: 'Prenom est requis.' },
    profil: { required: 'Profile est requis.' },
    email: { required: 'Email est requis.', pattern: 'Email format est invalide.' },
    telephone: { required: 'Telephone est requis.' },
    role: { required: 'role est requis.' }
  };

  profils: any[];
  agents: any[];
  selectedValues: string[] = [];
  profil: any;
  listDroit = [];
  constructor(
    private agentService: AgentService,
    private authService: AuthService,
    private confirmationService: ConfirmationService) {
  }

  async ngOnInit() {
    await this.getFonctionnalites();
    console.log('listDroit: ', this.listDroit);
    await this.getProfils();
    let list = [];
    this.profil = this.profils[0].id;
    this.profils[0].listDroit.forEach(e => {
      list.push(e.code);
    });
    this.selectedValues = list;
    console.log('element: ', this.selectedValues);
  }
  async getProfils() {
    this.profils = (await this.agentService.getProfils().toPromise() as any);
    this.listProfil = this.profils.map(e => {
      return { label: e.titre, value: e.id };
    });
  }

  async getFonctionnalites() {
    const data = (await this.agentService.getFonctionnalites().toPromise() as any);
    this.listDroit = data.map(e => {
      return { label: e.titre, value: e.code };
    });
  }

  async getProfil(id: any) {
    const data = (await this.agentService.getProfil(id).toPromise() as any);
    //this.profil = {value: data.id, label: data.titre};
    console.log('pro: ', this.profil);
    let list = [];
    data.listDroit.forEach(e => {
      list.push(e.code);
    });
    this.selectedValues = list;
  }

  async saveProfil() {
    this.displaychargement = true;
    if (!this.editMode) {
      const dataToSend = {
        titre: this.profil,
        detail: this.profil,
        listDroit: this.selectedValues.map(e => {
          return { code: e, profil_id: this.profil.id || this.profil };
        })
      };
      console.log('data: ', dataToSend);
      try {
        await this.agentService.saveProfil(dataToSend).toPromise();
        this.msgs = []; this.msgs.push({ severity: 'info', summary: 'info', detail: 'Tratitement effectué avec succès' });
      } catch (error) {
        this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: 'Tratitement échoué' });
      } finally {
        this.displaychargement = false;
        this.retrour();
      }
    } else {
      const dataToSend = {
        id: this.profil,
        listDroit: this.selectedValues.map(e => {
          return { code: e, profil_id: this.profil.id || this.profil };
        })
      };
      console.log('data: ', dataToSend);
      try {
        await this.agentService.editProfil(dataToSend).toPromise();
        this.msgs = []; this.msgs.push({ severity: 'info', summary: 'info', detail: 'Tratitement effectué avec succès' });
      } catch (error) {
        this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: 'Tratitement échoue' });
      } finally {
        this.displaychargement = false;
        this.retrour();
      }
    }
  }

  async onChange(event) {
    console.log('value: ', event.value);
    this.displaychargement = true;
    await this.getProfil(event.value);
    this.displaychargement = false;
  }

  newElement() {
    this.editMode = false;
    this.selectedValues = [];
    this.profil = '';
  }
  retrour() {
    this.editMode = true;
    this.ngOnInit();
  }
}
